export const ROOT_SCHEMA_TYPES = ['object', 'string', 'number', 'integer', 'boolean'] as const;
export const NODE_SCHEMA_TYPES = [...ROOT_SCHEMA_TYPES, 'array'] as const;
export const ARRAY_ITEM_TOKEN = '[]';

export type StructuredOutputRootSchemaType = (typeof ROOT_SCHEMA_TYPES)[number];
export type StructuredOutputNodeType = (typeof NODE_SCHEMA_TYPES)[number];
export type UnsupportedSchemaFields = Record<string, unknown>;
export type StructuredOutputSchemaPath = string[];

type StructuredOutputSchemaNodeBase = {
  description?: string;
  unsupported?: UnsupportedSchemaFields;
};

export type StructuredOutputObjectNode = StructuredOutputSchemaNodeBase & {
  type: 'object';
  properties: Record<string, StructuredOutputSchemaNode>;
  required: string[];
};

export type StructuredOutputArrayNode = StructuredOutputSchemaNodeBase & {
  type: 'array';
  items: StructuredOutputSchemaNode;
};

export type StructuredOutputStringNode = StructuredOutputSchemaNodeBase & {
  type: 'string';
  enum?: string[];
};

export type StructuredOutputNumberNode = StructuredOutputSchemaNodeBase & {
  type: 'number';
};

export type StructuredOutputIntegerNode = StructuredOutputSchemaNodeBase & {
  type: 'integer';
};

export type StructuredOutputBooleanNode = StructuredOutputSchemaNodeBase & {
  type: 'boolean';
};

export type StructuredOutputSchemaNode =
  | StructuredOutputObjectNode
  | StructuredOutputArrayNode
  | StructuredOutputStringNode
  | StructuredOutputNumberNode
  | StructuredOutputIntegerNode
  | StructuredOutputBooleanNode;

export type StructuredOutputSchemaTreeEntry = {
  path: StructuredOutputSchemaPath;
  pathKey: string;
  name: string;
  depth: number;
  node: StructuredOutputSchemaNode;
};

export type StructuredOutputSchemaParseSuccess = {
  ok: true;
  value: StructuredOutputSchemaNode;
  unsupportedCount: number;
  unsupportedPaths: string[];
};

export type StructuredOutputSchemaParseError = {
  ok: false;
  error: string;
  value: StructuredOutputSchemaNode;
  unsupportedCount: number;
  unsupportedPaths: string[];
};

export type StructuredOutputSchemaParseResult =
  | StructuredOutputSchemaParseSuccess
  | StructuredOutputSchemaParseError;
